import { type MCPServerInfo } from '../../types';

const GithubServer: MCPServerInfo = {
  serverId: 'GITHUB',
  name: 'GitHub',
  slug: 'github',
  description: 'GitHub MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.githubcopilot.com/mcp/'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['githubPersonalAccessToken'],
    properties: {
      githubPersonalAccessToken: {
        type: 'string',
        description: 'The personal access token for accessing the GitHub API.',
        sensitive: true
      }
    }
  }
};

export default GithubServer;
